<p-dialog header="Header"
          [(visible)]="visible"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          styleClass="w-[50vw] max-w-full lg:w-[33.33vw]">
  <ng-template #header>
    <div class="flex-flex-col w-full gap-1">
      <label class="text-left font-bold">{{ isNew ? ( 'newUser' | translate ) : ( 'editUser' | translate ) }}</label>
      <p-divider />
    </div>
  </ng-template>

  <div class="flex flex-col gap-3">
    <div class="grid w-full grid-cols-3 items-center gap-2 px-4 py-2">
      <label for="email" class="text-left text-sm font-semibold">E-Mail</label>
      <input pInputText id="email" class="col-span-2" type="email" [disabled]="!isNew" [(ngModel)]="user.userName" />

      <label for="name" class="text-left text-sm font-semibold">{{ 'name' | translate}}</label>
      <input pInputText id="name" class="col-span-2" autocomplete="off" [(ngModel)]="user.firstName" />

      <label for="surname" class="text-left text-sm font-semibold">{{ 'surname' | translate}}</label>
      <input pInputText id="surname" class="col-span-2" autocomplete="off" [(ngModel)]="user.lastName" />

      @if (!isNew){
      <hr class="col-span-3" />
      <div class="border-round shadow-1 col-span-3 flex items-center justify-between px-4 py-2">
        <div class="flex items-center gap-3">
          <p-toggleswitch [(ngModel)]="user.isActive"></p-toggleswitch>
          <span [ngClass]="user.isActive ? 'text-green-600 font-semibold': 'text-red-500 font-semibold'">
            {{ user.isActive ? ('active' | translate) : ('deactivated' | translate) }}
          </span>
        </div>
        <i class="pi"
           [ngClass]="user.isActive ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-400'"
           style="font-size: 1.4rem;"></i>
      </div>

      <hr class="col-span-3" />
      <div class="col-span-3 flex flex-row justify-end gap-3 py-3">
        <p-button [label]="'messages.emailResend' | translate" variant="outlined" [disabled]="isNew" (click)="onResendEMail($event)" />
        <p-button label="Reset Password" variant="outlined" [disabled]="isNew" (click)="onResetPassword($event)" />
      </div>
      }
    </div>
    <p-tabs [(value)]="tabsId">
      <p-tablist>
        <p-tab value="0">{{ 'operatingProfile' | translate}}</p-tab>
        @if(!isNew) {
        <p-tab value="1">{{ 'consents.consents' | translate}}</p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <div class=" flex flex-col gap-2 px-4 py-2">
            <div class="flex flex-col">
              <label plabel for="roles" class="text-xs">{{ 'roles' | translate}}</label>
              <app-role-select id="roles" [items]="user.roles" (itemsChange)="user.roles = $event"></app-role-select>
            </div>

            <div class="flex flex-col">
              <label plabel for="orgs" class="text-xs">{{ 'organizations' | translate}}</label>
              <app-organization-select id="orgs" [items]="user.organizations" (itemsChange)="onOrganizationsChange($event)"></app-organization-select>
            </div>

            <div class="flex flex-col">
              <label plabel for="depts" class="text-xs">{{ 'departments' | translate}}</label>
              <app-department-select id="depts" [items]="user.organizations" (itemsChange)="user.organizations = $event"></app-department-select>
            </div>
          </div>

        </p-tabpanel>
        @if(!isNew) {
        <p-tabpanel value="1">
          <div class="grid grid-cols-2 items-center gap-3 px-4 py-2">
            <label class="col-start-1 text-left">{{ 'consents.gdpr' | translate}}</label>
            <p-selectbutton [options]="stateOptions" [(ngModel)]="user.consents.gdprConsent" optionLabel="label" optionValue="value" [disabled]="true" />

            <label class="col-start-1 text-left">{{ 'consents.healthData' | translate}}</label>
            <p-selectbutton [options]="stateOptions" [(ngModel)]="user.consents.sanitaryConsent" optionLabel="label" optionValue="value" [disabled]="true" />

            <label class="col-start-1 text-left">{{ 'consents.terms' | translate}}</label>
            <p-selectbutton [options]="stateOptions" [(ngModel)]="user.consents.tcConsent" optionLabel="label" optionValue="value" [disabled]="true" />

            <p-divider class="col-start-1 col-end-3" />

            <label class="col-start-1 text-left">{{ 'consents.email' | translate}}</label>
            <p-selectbutton [options]="stateOptions" [(ngModel)]="user.consents.emailConfirmed" optionLabel="label" optionValue="value" [disabled]="true" />
          </div>
        </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  </div>

  <ng-template #footer>
    <p-button [label]="'primeng.cancel' | translate"
              [text]="true"
              severity="secondary"
              variant="outlined"
              (click)="onClose()" />
    <p-button [label]="'save' | translate"
              [disabled]="user.organizations.length === 0"
              (click)="onSave()" />
  </ng-template>
</p-dialog>
